import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapViewComponent } from './map-view.component';
import { AgmCoreModule } from '@agm/core';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { MaterialModule } from 'src/app/shared/material/material.module';

@NgModule({
  declarations: [MapViewComponent],
  imports: [CommonModule, FormsModule, MatSliderModule,MaterialModule],
  exports: [MapViewComponent],
})
export class MapViewModule {}
